import React from 'react';
import { activity_filters_filter, activity_filters_activityType, activity_filters_period, activity_filters_completionStatus, activity_filters_options_all, activity_filters_options_today, activity_filters_options_thisWeek, activity_filters_options_thisMonth, activity_filters_options_completed, activity_filters_options_incomplete, activity_activityTypes_learning, activity_activityTypes_project, activity_activityTypes_problemSolving, activity_activityTypes_challenge, activity_activityTypes_test, activity_activityTypes_discussion } from '@paraglide/messages';
// Lucide React 직접 import - Vite 번들링 최적화 및 초기화 순서 문제 해결
import { CalendarClock } from 'lucide-react';
import { Filter } from 'lucide-react';
var ActivityFiltersComponent = function(param) {
    var filters = param.filters, onFilterChange = param.onFilterChange;
    // 활동 유형을 '전체', '학습', '프로젝트'로 제한
    var activityTypes = [
        'all',
        'learning',
        'project'
    ];
    var periodOptions = [
        'today',
        'thisWeek',
        'thisMonth',
        'all'
    ];
    var completionOptions = [
        'all',
        'completed',
        'incomplete'
    ];
    var getActivityTypeLabel = function(type) {
        switch(type){
            case 'all':
                return activity_filters_options_all();
            case 'learning':
                return activity_activityTypes_learning();
            case 'project':
                return activity_activityTypes_project();
            case 'problemSolving':
                return activity_activityTypes_problemSolving();
            case 'challenge':
                return activity_activityTypes_challenge();
            case 'test':
                return activity_activityTypes_test();
            case 'discussion':
                return activity_activityTypes_discussion();
            default:
                return type;
        }
    };
    var getPeriodLabel = function(period) {
        switch(period){
            case 'all':
                return activity_filters_options_all();
            case 'today':
                return activity_filters_options_today();
            case 'thisWeek':
                return activity_filters_options_thisWeek();
            case 'thisMonth':
                return activity_filters_options_thisMonth();
            default:
                return period;
        }
    };
    var getCompletionLabel = function(status) {
        switch(status){
            case 'all':
                return activity_filters_options_all();
            case 'completed':
                return activity_filters_options_completed();
            case 'incomplete':
                return activity_filters_options_incomplete();
            default:
                return status;
        }
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: "bg-gray-50 dark:bg-gray-900 p-4 border-b border-gray-200 dark:border-gray-800"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex items-center gap-2 mb-3"
    }, /*#__PURE__*/ React.createElement(Filter, {
        className: "h-4 w-4 text-gray-500"
    }), /*#__PURE__*/ React.createElement("h2", {
        className: "text-sm font-medium"
    }, activity_filters_filter())), /*#__PURE__*/ React.createElement("div", {
        className: "grid grid-cols-1 md:grid-cols-3 gap-4"
    }, /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("label", {
        htmlFor: "activity-type",
        className: "block text-xs font-medium text-gray-500 dark:text-gray-400 mb-1.5"
    }, activity_filters_activityType()), /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-wrap gap-1.5"
    }, activityTypes.map(function(type) {
        return /*#__PURE__*/ React.createElement("button", {
            key: type,
            className: "px-2.5 py-1 text-xs rounded-full transition-colors ".concat(filters.type === type ? 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200' : 'bg-gray-100 text-gray-700 dark:bg-gray-800 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700'),
            onClick: function() {
                return onFilterChange('type', type);
            }
        }, getActivityTypeLabel(type));
    }))), /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("label", {
        htmlFor: "period",
        className: "block text-xs font-medium text-gray-500 dark:text-gray-400 mb-1.5 flex items-center"
    }, /*#__PURE__*/ React.createElement(CalendarClock, {
        className: "h-3.5 w-3.5 mr-1"
    }), activity_filters_period()), /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-wrap gap-1.5"
    }, periodOptions.map(function(period) {
        return /*#__PURE__*/ React.createElement("button", {
            key: period,
            className: "px-2.5 py-1 text-xs rounded-full transition-colors ".concat(filters.period === period ? 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200' : 'bg-gray-100 text-gray-700 dark:bg-gray-800 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700'),
            onClick: function() {
                return onFilterChange('period', period);
            }
        }, getPeriodLabel(period));
    }))), /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("label", {
        htmlFor: "completion-status",
        className: "block text-xs font-medium text-gray-500 dark:text-gray-400 mb-1.5"
    }, activity_filters_completionStatus()), /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-wrap gap-1.5"
    }, completionOptions.map(function(status) {
        return /*#__PURE__*/ React.createElement("button", {
            key: status,
            className: "px-2.5 py-1 text-xs rounded-full transition-colors ".concat(filters.completed === status ? 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200' : 'bg-gray-100 text-gray-700 dark:bg-gray-800 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700'),
            onClick: function() {
                return onFilterChange('completed', status);
            }
        }, getCompletionLabel(status));
    })))));
};
export default ActivityFiltersComponent;
